var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"back-button",attrs:{"to":_vm.to}},[_c('v-icon',[_vm._v("arrow_back")]),_vm._v(_vm._s(_vm.$t('back'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }